import { render, staticRenderFns } from "./CardTitleClose.vue?vue&type=template&id=3bc52112&scoped=true"
import script from "./CardTitleClose.vue?vue&type=script&lang=js"
export * from "./CardTitleClose.vue?vue&type=script&lang=js"
import style0 from "./CardTitleClose.vue?vue&type=style&index=0&id=3bc52112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc52112",
  null
  
)

export default component.exports